var React = require('react');

function IconTwitter (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M25.3 6.38c-.68 1-1.53 1.9-2.52 2.6.02.22.02.44.02.66C22.8 16.3 17.72 24 8.44 24c-2.86 0-5.52-.83-7.75-2.27.4.05.8.07 1.2.07 2.32 0 4.5-.8 6.22-2.16-2.22-.05-4.08-1.5-4.72-3.5.33.05.64.08.97.08.45 0 .9-.06 1.32-.17-2.3-.47-4.06-2.5-4.06-4.96V11c.65.38 1.43.6 2.26.64-1.35-.9-2.24-2.45-2.24-4.2 0-.94.25-1.8.7-2.55 2.47 3.03 6.2 5.03 10.4 5.3-.08-.4-.13-.8-.13-1.2.06-2.75 2.3-5 5.1-5 1.44 0 2.75.6 3.67 1.6 1.17-.25 2.27-.67 3.2-1.25-.34 1.18-1.14 2.16-2.2 2.8 1-.12 2-.4 2.9-.8z"}));
}

IconTwitter.displayName = "IconTwitter";

IconTwitter.defaultProps = {"width":"26","height":"28","viewBox":"0 0 26 28"};

module.exports = IconTwitter;

IconTwitter.default = IconTwitter;
